import * as general from '@/utils/mixins/general'
import { lazyLoadModal } from '@/utils/mixins/lazy-load-modal'
import refDimensions from '@/utils/mixins/ref-dimensions'
import oneTrust from '@/utils/mixins/one-trust'

export default {
  ...general,
  lazyLoadModal,
  refDimensions,
  oneTrust
}
